import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { signInWithCustomToken } from "firebase/auth";
import init from "../firebase";

const LoginWithToken = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  const package_id = searchParams.get("package_id");
  useEffect(() => {
    if (token) {
      signInWithCustomToken(init.auth, token)
        .then((userCredential) => {
          console.log("Logged in with token:", userCredential.user);
          if (package_id) {
            navigate(`/dashboard/edit_package/${package_id}`);
            return;
          } else {
            navigate("/dashboard/dash_board");
          }
        })
        .catch((err) => {
          console.error("Login failed:", err);
          navigate("/login");
        });
    } else {
      navigate("/login");
    }
  }, [token, navigate]);

  return <p>Logging in with token, please wait...</p>;
};

export default LoginWithToken;